import { Button } from '../buttons/Button';
import { cn } from '../../lib/helpers';

interface PlanTeaserCardProps {
    onStart: () => void;
    // Na stránce plánu se odznak neukazuje — název je už v nadpisu stránky.
    showBadge?: boolean;
}

export function PlanTeaserCard({
    onStart,
    showBadge = true,
}: PlanTeaserCardProps) {
    return (
        <div className="rounded-2xl border-2 border-product-500 bg-white p-5 shadow-sm">
            {showBadge && (
                <span className="rounded-lg bg-product-100 px-3 py-1 text-xs font-medium text-product-600">
                    Nové · Plán na míru
                </span>
            )}
            <div
                className={cn(
                    'flex flex-wrap items-center gap-4',
                    showBadge && 'mt-3'
                )}
            >
                <div className="min-w-[220px] flex-1">
                    <h5>Jak na tom je vaše třída?</h5>
                    <p className="text-sm text-ink-800">
                        Dotazník od psychologů odhalí, co vaše třída teď
                        nejvíc potřebuje. Zabere méně než 5 minut.
                    </p>
                </div>
                <Button color="product" onClick={onStart}>
                    Zjistit — 5 min
                </Button>
            </div>
            <p className="mt-3 text-[13px] text-ink-700">
                Zdarma i v demoverzi · výsledky uvidíte hned
            </p>
        </div>
    );
}
